import { render, staticRenderFns } from "./AppSelectRadio.vue?vue&type=template&id=45062242"
import script from "./AppSelectRadio.vue?vue&type=script&lang=js"
export * from "./AppSelectRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports